import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {ImageresizeApi, Raven} from 'modules';
import {BannerAd, Loader} from 'components';
import {validateProcessResponse} from 'utils';
import intl from 'react-intl-universal';

import PdfSelect from 'containers/PdfResize/PdfSelect';
import PdfAdjust from 'containers/PdfResize/PdfAdjust';
import PdfDownload from 'containers/PdfResize/PdfDownload';

export default class PdfResize extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: 'select',
      bulkImages: [],
      convertedImages: [
        {
          originalImage: {name: 'test', size: 'A5'},
          contentLength: 123456,
          size: 'A4'
        }
      ]
    };
  }

  removeImage = (id) => this.setState(({ bulkImages }) => ({
    bulkImages: bulkImages.filter((image) => image.imageId !== id)
  }));

  resizeImages = (images) => {
    let convertedImages;

    // TODO: Get a real progress indicator since this takes a while
    // Maybe this: https://tympanus.net/codrops/2014/04/09/how-to-create-a-circular-progress-button/
    this.setState({
      step: 'loading'
    });
    // this.setState({step: 'download'});
    ImageresizeApi.editImages(images)
      .then(validateProcessResponse)
      .then(({ results }) => {
        convertedImages = results.map((result, idx) => ({
          originalImage: this.state.bulkImages[idx],
          pdfResize: images[idx].pdfResize,
          pdfScale: images[idx].pdfScale,
          newSize: images[idx].newSize,
          ...result
        }));

        return ImageresizeApi.createArchive(convertedImages, 'Images');
      })
      .then(validateProcessResponse)
      .then(({ results }) => this.setState({
        step: 'download',
        result: results[0],
        convertedImages
      }))
      .catch((error) => this.setState({
        step: 'error',
        error
      }));
  };

  handleImagesUploaded = (bulkImages) => this.setState({
    step: 'adjust',
    bulkImages
  });

  handleUploadErrors = (errors) => {
    this.setState({
      step: 'error',
      error: new Error(errors[0])
    })
    
    Raven.clog(errors[0], "BulkResize");
  };
  renderError() {
    const {error} = this.state;

    return (
      <div className='error'>
        <p>{intl.get('The image could not be resized:')}</p>
        <p className='errorMessage'>{error.message}</p>
      </div>
    );
  }

  renderStep() {
    const {step, bulkImages, convertedImages, result} = this.state;

    // console.log(step)
    switch (step) {
      case 'select':
        return (
          <PdfSelect
            onDone={this.handleImagesUploaded}
            onErrors={this.handleUploadErrors}
          />
        );
      case 'adjust':
        return (
          <PdfAdjust
            bulkImages={bulkImages}
            removeImage={this.removeImage}
            resizeImages={this.resizeImages}
          />
        );
      case 'download':
        return (
          <PdfDownload
            result={result}
            convertedImages={convertedImages}
          />
        );
      case 'error':
        return this.renderError();
      case 'loading':
        return <Loader />;
      default:
        return null;
    }
  }

  render() {
    const shareUrl = ImageresizeApi.BASE_URL + '/pdf-resize';
    const title = 'PDF Resizer - Easily Resize PDF Online for Free';
    const desc = 'Easily change the paper size of your PDF files online for free. You can scale up or down to fit a specific paper size. Alternatively, you can resize pdf to fit a custom width and height.';
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content={desc}
          />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={desc} />
          <meta property="og:image" content="/social.png" />
          
        </Helmet>
        <BannerAd />
        {this.renderStep()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PdfResize/index.jsx